export class UserNotAllowedToDistributeTranscripts extends Error {
  constructor() {
    super('User is not allowed to distribute transcripts in this court system')
    Object.setPrototypeOf(this, UserNotAllowedToDistributeTranscripts.prototype)
  }
}
